<template>
  <AppNavigation />
  <div id="smooth-wrapper">
    <div id="smooth-content" class="ink-theme">
      <router-view />
      <Footer class="hidden md:flex md:flex-col"></Footer>
      <MobileFooter class="hidden max-[639px]:flex"></MobileFooter>
    </div>
  </div>
  <DeferredRuntimeServices />
</template>
<script setup lang="ts">
import Footer from "@/components/footer.vue";
import AppNavigation from "@/components/AppNavigation.vue";
import MobileFooter from "@/components/common-mobile/mobileFooter.vue";
import DeferredRuntimeServices from "@/components/runtime/DeferredRuntimeServices.vue";
</script>

<style>
/* ============================================================
 * 全局覆盖 @reimujs/aos 库内置的 `[data-aos]{pointer-events:none}` 规则。
 *
 * 那条库内置 CSS 让所有 data-aos 元素**初始就不接收点击**, 只有 .aos-animate
 * 加上之后才恢复 auto。一旦 AOS 因任何原因没正确给元素加 .aos-animate
 * (移动端 disable、ScrollSmoother 抢走 scroll 事件、组件挂载时机不对…),
 * 元素永远 pointer-events: none —— "看得见也点不到"。
 *
 * 视觉入场效果(opacity / transform / mask)与 hit-test 是两套独立链路,
 * 全局放开 pointer-events 不会让动画失真, 只是让 button 这种交互元素
 * 在任何阶段都能响应点击。!important 是为了盖过库的非-important 规则。
 * ============================================================ */
[data-aos] {
  pointer-events: auto !important;
}
</style>
